module.exports = __webpack_public_path__ + "assets/ad8ecc27d1628e4a19936c54ebba5524.png";